"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
interface DebounceOptions {
  minDelay: number;
  maxDelay: number;
  increaseFactor: number;
  decreaseFactor: number;
}
export const useProgressiveDebounce = (callback, dependencies, options) => {
  const $ = _c(6);
  const {
    minDelay,
    maxDelay,
    increaseFactor,
    decreaseFactor
  } = options;
  const delayRef = useRef(minDelay);
  let t0;
  if ($[0] !== callback || $[1] !== decreaseFactor || $[2] !== increaseFactor || $[3] !== maxDelay || $[4] !== minDelay) {
    t0 = () => {
      const handler = setTimeout(() => {
        callback();
        delayRef.current = minDelay;
      }, delayRef.current);
      delayRef.current = Math.min(maxDelay, delayRef.current * increaseFactor);
      return () => {
        clearTimeout(handler);
        delayRef.current = Math.max(minDelay, delayRef.current / decreaseFactor);
      };
    };
    $[0] = callback;
    $[1] = decreaseFactor;
    $[2] = increaseFactor;
    $[3] = maxDelay;
    $[4] = minDelay;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  useEffect(t0, dependencies);
};